import { render, staticRenderFns } from "./DITSensorOnboarding.vue?vue&type=template&id=539b2cb4&scoped=true&"
import script from "./DITSensorOnboarding.vue?vue&type=script&lang=js&"
export * from "./DITSensorOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./DITSensorOnboarding.vue?vue&type=style&index=0&id=539b2cb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539b2cb4",
  null
  
)

export default component.exports